import { Component, inject } from '@angular/core';
import { ViewportEnterDirective } from '../viewport-enter-directive';
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-how',
  standalone: true,
  imports: [ViewportEnterDirective],
  templateUrl: './how.html',
  styleUrl: './how.scss',
})
export class How {
  activeRoute= inject(ActiveRoute)
}
